import Vue from 'vue'
import Vuex from 'vuex'
import approvements from './store/approvements'
import auth from './store/auth'
import autos from './store/autos'
import bids from './store/bidsData'
import callCenter from './store/callCenter'
import clients from './store/clients'
import contracts from './store/contracts'
import contragent from './store/contragent'
import contragentGroup from './store/contragentGroup'
import defaultStevedore from './store/defaultstevedore'
import documentTypes from './store/documentTypes'
import driverWelcomePage from './store/driverWelcomePage'
import drivers from './store/drivers'
import edmUsers from './store/edmUsers'
import fastlink from './store/fastlink'
import group from './store/group'
import hardware from './store/hardware'
import libs from './store/libs'
import loadDay from './store/loadDay'
import managers from './store/managers'
import organizations from './store/organizations'
import payments from './store/payments'
import pole from '@/store/pole'
import registerOfPayments from '@/store/registerOfPayments'
import reportForwarder from '@/store/reportForwarder'
import reports from './store/reports'
import responseRequest from './store/responseRequest'
import responses from './store/responses'
import shipping from './store/shipping'
import statistic from './store/statistic'
import stevedores from './store/stevedores'
import tableOfPayments from '@/store/tableOfPayments'
import ui from './store/ui'
import userOrganizations from './store/userOrganizations'
import userProfile from './store/userprofile'
import users from './store/users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    responseRequest,
    tableOfPayments,
    libs,
    contragent,
    group,
    defaultStevedore,
    userProfile,
    fastlink,
    bids,
    drivers,
    auth,
    autos,
    managers,
    edmUsers,
    statistic,
    users,
    hardware,
    documentTypes,
    approvements,
    responses,
    stevedores,
    userOrganizations,
    ui,
    payments,
    shipping,
    contragentGroup,
    loadDay,
    reports,
    organizations,
    callCenter,
    clients,
    reportForwarder,
    registerOfPayments,
    contracts,
    driverWelcomePage,
    pole,
  },
  strict: process.env.NODE_ENV !== 'production',
})
